import React, { useState, useEffect, useMemo } from "react";
import { Formik, Form, FormikHelpers } from "formik";
import * as Yup from "yup";

//MUI
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";

import FormikControl from "../../components/formik/FormikControl";
import Loader from "../../components/loader/Loader";

import ProjectCompetitorsService from "../../services/ProjectCompetitorsService";
import { Mode } from "./ProjectCompetitorsPage";
import { ProjectCompetitorsModel } from "../../models/ProjectCompetitorsModel";
import { fetchProjectCompetitors } from "../../redux/actions/ProjectCompetitorsActions";
import { useAppDispatch, useAppSelector } from "../../redux/hooks/redux-hooks";

const validationSchema = Yup.object({
  id: Yup.number().required("Required"),
  name: Yup.string().required("Required"),
});

type FormProps = Yup.InferType<typeof validationSchema>;

type Props = {
  mode: Mode;
  handleModalClose: () => void;
  data?: ProjectCompetitorsModel;
};

const ProjectCompetitorsForm = ({ mode, handleModalClose, data }: Props) => {
  const initialValues = useMemo(
    () => ({
      id: 0,
      name: "",
    }),
    []
  );

  const [formState, setFormState] = useState<FormProps>(initialValues);
  const dispatch = useAppDispatch();
  const displayToast = useAppSelector((state) => state.toast.displayToast);

  useEffect(() => {
    if (mode === "edit" && data) {
      setFormState(() => ({
        id: data.id,
        name: data.name,
      }));
    }
  }, [mode, data]);

  const submitHandler = async (
    values: FormProps,
    actions: FormikHelpers<FormProps>
  ) => {
    try {
      let formData: ProjectCompetitorsModel = {
        id: 0,
        name: "",
        createdDate: new Date(),
      };
      if (mode === "add") {
        formData.id = 0;
        formData.name = values.name;
      } else if (data) {
        formData = {
          ...data,
          id: values.id,
          name: values.name,
        };
      }
      await ProjectCompetitorsService.createProjectCompetitor(formData, data?.id);
      actions.setSubmitting(false);
      handleModalClose();
      dispatch(fetchProjectCompetitors());
      displayToast(
        `Project Competitors ${
          mode === "add" ? "created" : "updated"
        } successfully`,
        "success"
      );
    } catch (error) {
      actions.setSubmitting(false);
    }
  };

  return (
    <Formik
      initialValues={formState}
      validationSchema={validationSchema}
      onSubmit={submitHandler}
      enableReinitialize={true}
    >
      {(formik) => (
        <>
          <Form>
            <Stack gap={2}>
              {/* <FormikControl
                control="input"
                type="text"
                name="id"
                size="small"
                label="Id"
                placeholder="Enter Id"
              /> */}
              <FormikControl
                control="input"
                type="text"
                name="name"
                size="small"
                label="Project Competitor Name"
                placeholder="Enter Competitor Name"
              />
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={formik.isSubmitting}
              >
                Submit
              </Button>
            </Stack>
          </Form>
          {formik.isSubmitting && <Loader />}
        </>
      )}
    </Formik>
  );
};

export default ProjectCompetitorsForm;
